import { types as t } from "../mutations/basket";

/**
 *
 * @type {{ADD_BASKET_ITEM: string, CLEAR_BASKET: string, REMOVE_BASKET_ITEM: string}}
 */
export const types = {
  ADD_BASKET_ITEM: "ADD_BASKET_ITEM",
  REMOVE_BASKET_ITEM: "REMOVE_BASKET_ITEM",
  CLEAR_BASKET: "CLEAR_BASKET",
  OPEN_BASKET: "OPEN_BASKET",
  CLOSE_BASKET: "CLOSE_BASKET",
  TOGGLE_BASKET: "TOGGLE_BASKET"
};

/**
 *
 * @type {{}}
 */
export const actions = {
  [types.ADD_BASKET_ITEM]: ({ commit }, { item, type }) => {
    commit(t.M_OPEN_BASKET);
    commit(t.M_ADD_BASKET_ITEM, { item, type });
  },
  [types.REMOVE_BASKET_ITEM]: ({ commit }, uuid) =>
    commit(t.M_REMOVE_BASKET_ITEM, uuid),
  [types.CLEAR_BASKET]: ({ commit }) => commit(t.M_CLEAR_BASKET)
};
